/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC} from 'react'
import {toAbsoluteUrl} from '../../../../../../../../../_metronic/helpers'
import {Loan} from '../../core/_models'

type Props = {
  loan: Loan
}

const LoanInfoCell: FC<Props> = ({loan}) => (
  <div className='d-flex align-items-center'>
    {/* begin:: Avatar */}
    {/* <div className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
      <a href='#'>
        {Loan.avatar ? (
          <div className='symbol-label'>
            <img src={toAbsoluteUrl(`/media/${Loan.avatar}`)} alt={Loan.name} className='w-100' />
          </div>
        ) : (
          <div
            className={clsx(
              'symbol-label fs-3',
              `bg-light-${Loan.initials?.state}`,
              `text-${Loan.initials?.state}`
            )}
          >
            {Loan.initials?.label}
          </div>
        )}
      </a>
    </div> */}
    <div className='d-flex flex-column'>
      <a href='#' className='text-gray-800 text-hover-primary mb-1'>
        {loan.name}
      </a>
      <span>{loan.email}</span>
    </div>
  </div>
)

export {LoanInfoCell}
